import React from "react";
import { ContactUsText2 } from "./__ContactUs";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";

const title = "Refund Policy";

const RefundPolicy = () => {
  return (
    <>
      <NavbarSave />
      <div className="bg-white w-100 h-100 overflow-y-auto" style={{ paddingTop: 156 }}>
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <RefundPolicyText />
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default RefundPolicy;

function RefundPolicyText() {
  return (
    <>
      <div className="fs-3 fw-semibold mt-5">1. Overview</div>
      <p className="fs-5">
        This Refund Policy governs all payments, purchases, and subscriptions made for 
        <strong> SAVE (Secure AI-Based Vulnerability Assessment Tool for Enterprises)</strong>, 
        a cybersecurity software solution developed, owned, and operated exclusively by 
        <strong> CYBERSECOPS PRIVATE LIMITED</strong>. By completing a payment or subscription on our platform, 
        you acknowledge that you have read, understood, and agreed to the terms outlined in this Refund Policy.
      </p>

      <div className="fs-3 fw-semibold mt-5">2. Nature of Our Services</div>
      <p className="fs-5">
        SAVE is a fully digital SaaS (Software-as-a-Service) cybersecurity tool provided for vulnerability 
        assessment and network protection. As our services involve immediate digital access, scanning, and 
        processing functions, all sales are considered final once a subscription or purchase is successfully 
        activated. CYBERSECOPS PRIVATE LIMITED does not deliver any physical goods or offline materials.
      </p>

      <div className="fs-3 fw-semibold mt-5">3. No Refund Policy</div>
      <p className="fs-5">
        All payments made towards SAVE subscriptions, upgrades, renewals, or enterprise licenses are 
        <strong>non-refundable</strong>. Once a transaction has been processed successfully, no refunds, reversals, 
        or chargebacks will be entertained under any circumstances, regardless of service usage, user inactivity, 
        or perceived performance issues. This policy ensures the security and integrity of our digital licensing process.
      </p>
      <p className="fs-5">
        The no-refund policy applies to all types of users, including individual, enterprise, and partner accounts, 
        across all subscription plans (monthly, yearly, or customized agreements).
      </p>

      <div className="fs-3 fw-semibold mt-5">4. Free Trial Policy</div>
      <p className="fs-5">
        To ensure complete user satisfaction and transparency, CYBERSECOPS PRIVATE LIMITED offers a 
        <strong> 15-day free trial</strong> of SAVE prior to any paid subscription. This allows potential users to 
        fully evaluate product features, dashboard functionality, and performance metrics before purchasing a paid plan. 
        We encourage all users to utilize this trial to determine product compatibility with their business or technical requirements.
      </p>

      <div className="fs-3 fw-semibold mt-5">5. Exceptional Circumstances</div>
      <p className="fs-5">
        While CYBERSECOPS PRIVATE LIMITED maintains a strict no-refund policy, certain exceptional cases may be 
        considered for review under the following conditions:
      </p>
      <ul className="fs-5">
        <li>Duplicate payment made accidentally for the same subscription period.</li>
        <li>Technical billing errors resulting in unauthorized or incorrect charges.</li>
        <li>Payment processed but service access not provisioned due to a verified internal fault.</li>
      </ul>
      <p className="fs-5">
        In such cases, refunds or credits may be approved solely at the discretion of the CYBERSECOPS PRIVATE LIMITED 
        management team after a complete verification of payment records and system logs. Refunds, if approved, 
        will be processed through the original payment method within 10–15 business days.
      </p>

      <div className="fs-3 fw-semibold mt-5">6. Subscription Cancellation</div>
      <p className="fs-5">
        Users may cancel their active SAVE subscription at any time. Cancellations will prevent future renewals or billing, 
        but will not entitle the user to a refund for the remaining period of the current billing cycle. 
        Access to SAVE will remain available until the current subscription term expires. 
        To avoid auto-renewal charges, cancellation requests should be made prior to the renewal date.
      </p>

      <div className="fs-3 fw-semibold mt-5">7. Payment Disputes and Chargebacks</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED discourages initiating chargebacks through payment gateways or banks 
        without prior communication. Any disputes or claims should be addressed directly to our support team. 
        We maintain detailed payment and activity records for each account to assist with accurate dispute resolution. 
        Fraudulent or invalid chargeback attempts may result in immediate suspension of SAVE account access 
        and potential legal recourse.
      </p>

      <div className="fs-3 fw-semibold mt-5">8. Service Downtime and Interruptions</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED takes all reasonable measures to ensure uninterrupted availability of SAVE services. 
        However, temporary downtime due to maintenance, system upgrades, or unforeseen technical issues does not 
        qualify for a refund or compensation. We will notify users of any scheduled maintenance or extended service 
        interruptions through official communication channels.
      </p>

      <div className="fs-3 fw-semibold mt-5">9. Modifications to This Policy</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED reserves the right to modify, amend, or update this Refund Policy at any time 
        without prior notice. Updates will be reflected by revising the “Last Updated” date on this page. 
        Users are encouraged to review this policy periodically to stay informed about any changes.
      </p>

      <div className="fs-3 fw-semibold mt-5">10. Contact Us</div>
      <p className="fs-5">
        If you have any questions, billing concerns, or believe you qualify for an exception under this Refund Policy, 
        please contact our support or billing department using the contact details below:
      </p>
      <ContactUsText2 />
    </>
  );
}
